import { Flex } from "@chakra-ui/react";

interface MeuFinanceiroCardProps {
  label: string;
  icon: any;
  iconBg: string;
}

function MeuFinanceiroCard({ label, icon, iconBg }: MeuFinanceiroCardProps) {
  return (
    <Flex
      boxShadow="0 0 24px rgba(0,0,0,.05)"
      flexDir="column"
      bg="white"
      rounded="16px"
      p="16px"
    >
      <Flex
        w="50px"
        h="50px"
        rounded="50%"
        justifyContent="center"
        alignItems="center"
        bg={iconBg}
      >
        {icon}
      </Flex>
      <Flex pt="8px" flexDir="column" fontSize="16px">
        {label}
      </Flex>
    </Flex>
  );
}

export default MeuFinanceiroCard;
